/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是ClChartLine的实体定义  --- 画线类

// 实际上就是获取某种类型数据，然后横坐标 0 开始排序，永远是数值型，但显示出什么要到对应的数组中找
// 纵坐标根据数据类型，计算最大最小值，然后根据画线类型画出数据线，所有的不同全部在ClChart中处理

import {
    _fillRect,
    _drawRect,
    _setLineWidth,
    _getTxtWidth,
    _drawBegin,
    _drawHline,
    _drawVline,
    _drawline,
    _clearRect,
    _drawDashLine,
    _drawEnd,
} from './cl.draw'

import {
    initCommonInfo,
    checkLayout,
    getLineColor,
} from './cl.chart.init'

import {
    ASCIIMAPS,
    CHART_LAYOUT
} from '../cl.chart.res'
import {
    updateJsonOfDeep,
    copyJsonOfDeep,
    offsetRect,
    mergeObjectOfDeep,
    isEmptyArray,
    formatInfo,
    inRangeX,
    getSize,
} from '../cl.utils'

import { 
    STOCK_TYPE_IDX,
    getValueFidx,
    getValue, 
} from '../datas/cl.data'

import ClChartButton from './cl.chart.button'
import ClChartScroll from './cl.chart.scroll'
import ClDrawAxisX from './cl.draw.axisX'
import ClDrawAxisY from './cl.draw.axisY'
import ClDrawCursor from './cl.draw.cursor'
import ClDrawGrid from './cl.draw.grid'
import ClDrawInfo from './cl.draw.info'

/**
 * Class representing ClChartLine
 * @export
 * @class ClChartLine
 */
export default class ClChartLine {
    /**

     * Creates an instance of ClChartLine.
     * @param {Object} father line chart's parent context
     */
    constructor(father) {
        initCommonInfo(this, father)

        this.dataLayer = father.dataLayer
        this.linkInfo = this.dataLayer.linkInfo

        this.static = this.linkInfo.static
        // console.log(this.static);
        
        this.data = {}
        this.axisYdata = {}
    }
    /**
     * init line
     * @param {Object} cfg line's config
     * @param {any} callback initialized callback
     * @memberof ClChartLine
     */
    init(cfg, callback) {
        this.callback = callback
        this.rectMain = cfg.rectMain || {
            left: 0,
            top: 0,
            width: 400,
            height: 200
        }

        this.layout = updateJsonOfDeep(cfg.layout, CHART_LAYOUT)
        
        this.config = copyJsonOfDeep(cfg.config)
        // 这里直接赋值是因为外部已经设置好了配置才会开始初始化
        this.buttons = cfg.config.buttons || []
        // console.log(cfg, this.buttons);
        this.scroll = cfg.config.scroll || {
            display: 'none'
        }
        this.childCharts = {}

        // 下面对配置做一定的校验
        this.checkConfig()
        // 再做一些初始化运算，下面的运算范围是初始化设置后基本不变的数据
        this.setPublicRect()
        // 初始化子窗口
        this.childDraws = {}
        this.setChildDraw()
        this.childLines = {}
        this.setChildLines()
        // 初始化按钮
        this.createButtons()
        // 初始化滚动条
        this.setScroll()
        
        // console.log(this.config);
        
        // this.style = this.config.style || 'normal'
        // if (this.style  === 'fwindow') {
        //     this.context = this.father.swimCanvas.context
        // }
    }
    changeCfg(newcfg) {
        // console.log(this.config.lines, newcfg);
        
        if (newcfg.lines !== undefined) {
            this.config.lines = newcfg.lines
            this.childLines = {}
            this.setChildLines()
            this.axisYdata = {}
            this.data = {}
        }
        if (newcfg.axisX !== undefined) {
            this.config.axisX = mergeObjectOfDeep(newcfg.axisX, this.config.axisX)
        }
        if (newcfg.axisY !== undefined) {
            this.config.axisY = mergeObjectOfDeep(newcfg.axisY, this.config.axisY)
        }
        if (newcfg.title !== undefined) {
            this.config.title = mergeObjectOfDeep(newcfg.title, this.config.title)
        }
        if (newcfg.rectMain !== undefined) {
            this.rectMain = newcfg.rectMain
            this.setPublicRect()
        }
        // console.log(this.config);
        this.onPaint()
    }
    setWindowMark(opendate, stopdate, currdate) {
        if (currdate > stopdate) {
            currdate = stopdate;
        }
        if (currdate < opendate) {
            currdate = opendate;
        }
        this.windowMark = {
            min : opendate,
            max : stopdate,
            cur : currdate,
        }
        // if (ldays === undefined) {
        //     ldays = 30
        // }
        // if (rdays === undefined) {
        //     rdays = ldays
        // }
        // this.linkInfo.fixed.left = ldays
        // this.linkInfo.fixed.right = rdays   
    }
    /**
     * check config
     * @memberof ClChartLine
     */
    checkConfig() { // 检查配置有冲突的修正过来
        checkLayout(this.layout)
        this.config.title.spaceX = this.config.title.spaceX * this.scale || this.layout.title.spaceX
        this.config.title.pixel = this.config.title.pixel * this.scale || this.layout.title.pixel
        this.initZoomInfo()
    }
    /**
     * set public rect
     * @memberof ClChartLine
     */
    setPublicRect() { // 计算所有矩形区域
        // rectChart 画图区
        // rectTitle rectMess
        // rectAxisX
        // rectScroll
        // rectAxisYLeft rectAxisYRight
        // rectGridLine 坐标线区域

        this.rectChart = offsetRect(this.rectMain, this.layout.margin)
        // console.log(this.config.title);
        const numlen = _getTxtWidth(this.context, '8', this.config.title.font, this.config.title.pixel)

        let titleWidth = 0
        if (this.config.title.label !== undefined) {
            titleWidth = _getTxtWidth(this.context, this.config.title.label, 
                this.config.title.font, this.config.title.pixel) + 2 * this.scale
        }
        if (this.config.title.maxchs !== undefined) {
            titleWidth = Math.max(titleWidth, numlen * this.config.title.maxchs)
        }
        else {
            titleWidth = Math.max(titleWidth, numlen * this.layout.axisX.maxchs)
        }

        // 计算title和mess矩形位置
        this.rectTitle = {
            left: this.rectMain.left,
            top: this.rectMain.top,
            width: 0,
            height: 0
        }
        this.rectMess = {
            left: this.rectMain.left,
            top: this.rectMain.top,
            width: 0,
            height: 0
        }
        this.rectButton = {
            left: this.rectMain.left,
            top: this.rectMain.top,
            width: 0,
            height: 0
        }
        if (this.config.title.display !== 'none') {
            this.rectTitle = {
                left: this.rectChart.left,
                top: this.rectChart.top,
                width: titleWidth,
                height: this.layout.title.height
            }
            const rightW = 2 * this.scale
            if (this.buttons.length > 0) {
                const btnh = this.layout.title.height - 4 * this.scale
                const btnw = this.buttons.length * btnh + 4 * this.scale
                this.rectButton = {
                    left: this.rectChart.left + this.rectChart.width - btnw - rightW,
                    top: this.rectChart.top + 2 * this.scale,
                    width: btnw,
                    height: btnh
                }
            }
            this.rectMess = {
                left: this.rectChart.left + titleWidth + this.scale,
                top: this.rectChart.top,
                width: this.rectChart.width - titleWidth - this.rectButton.width - rightW - this.scale,
                height: this.layout.title.height
            }

        }
        // console.log(this.rectTitle);
        
        const axisInfo = {} 
        // 计算rectAxisX和rectScroll矩形位置
        axisInfo.left = this.rectChart.left
        axisInfo.right = this.rectChart.left + this.rectChart.width
        axisInfo.top = this.rectTitle.top + this.rectTitle.height
        axisInfo.bottom = this.rectChart.top + this.rectChart.height

        if (this.axisPlatform !== 'phone') {
            if (this.config.axisY.left.display !== 'none') axisInfo.left += numlen * this.layout.axisX.maxchs
            if (this.config.axisY.right.display !== 'none') axisInfo.right -= numlen * this.layout.axisX.maxchs
        }
        if (this.config.axisX.display !== 'none') {
            axisInfo.bottom -= this.layout.axisX.height
        }
        // console.log(this.layout.scroll.size, axisInfo.bottom);
        if (this.scroll.display !== 'none') {
            axisInfo.bottom -= this.layout.scroll.size
        }
        // 此时已经可以得出画坐标线的区域了
        this.rectGridLine = {
            left: axisInfo.left,
            top: axisInfo.top,
            width: axisInfo.right - axisInfo.left,
            height: axisInfo.bottom - axisInfo.top
        }
        let axisWidth = 0
        if (this.config.axisY.display !== 'none') {
            axisWidth = numlen * this.layout.axisX.maxchs
        }
        this.rectAxisYLeft = {
            left: this.rectChart.left,
            top: axisInfo.top,
            width: axisWidth,
            height: axisInfo.bottom - axisInfo.top
        }
        this.rectAxisYRight = {
            left: this.rectChart.left + this.rectChart.width - axisWidth,
            top: axisInfo.top,
            width: axisWidth,
            height: axisInfo.bottom - axisInfo.top
        }

        this.rectChart = offsetRect(this.rectGridLine, this.layout.offset)

        this.rectAxisX = {
            left: 0,
            top: axisInfo.bottom,
            width: 0,
            height: 0
        }
        if (this.config.axisX.display !== 'none') {
            this.rectAxisX = {
                left: axisInfo.left,
                top: axisInfo.bottom + this.scale,
                width: axisInfo.right - axisInfo.left,
                height: this.layout.axisX.height
            }
        }
        if (this.scroll.display !== 'none') {
            this.rectScroll = {
                left: axisInfo.left,
                // top: this.rectAxisX.top + this.rectAxisX.height + this.scale,
                top: this.rectAxisX.top + this.rectAxisX.height,
                width: axisInfo.right - axisInfo.left,
                height: this.layout.scroll.size
            }
        }
    }
    /**
     * get line by data key
     * @param {String} line
     * @return {Object} line instance
     * @memberof ClChartLine
     */
    getLineDataKey(line) {
        if (line.formula === undefined) return this.hotKey
        return line.formula.key
    }
    /**
     * set child line instance
     * @memberof ClChartLine
     */
    setChildLines() {
        // l_kbar，l_line，l_nowvol，l_vbar l_nowline
        let line
        let clr = 0
        for (let i = 0; i < this.config.lines.length; i++) {
            const ClassName = this.config.lines[i].className
            line = new ClassName(this, this.rectChart)

            this.childLines['NAME' + i] = line
            line.name = 'NAME' + i
            line.hotKey = this.getLineDataKey(this.config.lines[i])
            if (this.config.lines[i].info === undefined) {
                line.info = {
                    fieldX: 'index',
                    fieldY: 'value'
                }
            } else {
                line.info = this.config.lines[i].info
            }
            if (line.info.colorIndex === undefined) {
                line.info.colorIndex = clr
            }
            if (this.config.lines[i].formula === undefined) {
                line.info.alone = true
            }
            else {
                line.info.alone = false
            }
            clr++
        }
    }
    /**
     * set child draw instance
     * @memberof ClChartLine
     */
    setChildDraw() {
        let draw
        draw = new ClDrawCursor(this, {
            rectMain: this.rectGridLine,
            rectChart: this.rectChart,
            style: 'cross'
        })
        this.childDraws['CURSOR'] = draw

        if (this.config.title.display !== 'none') {
            draw = new ClDrawInfo(this, this.rectTitle, this.rectMess)
            this.childDraws['TITLE'] = draw
        }
        if (this.config.axisY.left.display !== 'none') {
            draw = new ClDrawAxisY(this, this.rectAxisYLeft, 'left')
            this.childDraws['AXISY_LEFT'] = draw
        }
        if (this.config.axisY.right.display !== 'none') {
            draw = new ClDrawAxisY(this, this.rectAxisYRight, 'right')
            this.childDraws['AXISY_RIGHT'] = draw
        }
        if (this.config.axisX.display !== 'none') {
            draw = new ClDrawAxisX(this, this.rectAxisX)
            this.childDraws['AXISX'] = draw
        }
        draw = new ClDrawGrid(this, this.rectGridLine)
        this.childDraws['GRID'] = draw
        // 下面是line的定义
    }
    /**
     * set scroll instance
     * @memberof ClChartLine
     */
    setScroll() {
        if (this.scroll.display === 'none') return
        const chart = new ClChartScroll(this)
        chart.name = 'HSCROLL'
        chart.father = this
        this.childCharts[chart.name] = chart

        chart.init({
                rectMain: this.rectScroll,
                config: {
                    width: 8
                }
            },
            result => {
                // console.log(result, this.linkInfo);
                if (this.linkInfo.minIndex !== result.minIndex) {
                    this.linkInfo.minIndex = result.minIndex
                    if (this.linkInfo.showMode === 'scroll') {
                        if (this.linkInfo.maxIndex === getSize(this.data) - 1) {
                            this.linkInfo.showMode = 'init'
                        }
                        this.linkInfo.scroll.index = -1
                        this.father.fastDrawEnd()
                        this.father.onPaint()
                    }
                    else {
                        const showMode = this.linkInfo.showMode
                        this.linkInfo.scroll.index = -1
                        this.linkInfo.showMode = 'scroll'
                        this.father.fastDrawEnd()
                        this.father.onPaint()
                        if (showMode === 'locked') {
                            this.changeLocked()
                        }
                    }
                }
                // if (this.linkInfo.maxIndex !== result.maxIndex || this.linkInfo.minIndex !== result.minIndex) {
                //     this.linkInfo.minIndex = result.minIndex
                //     this.linkInfo.maxIndex = result.maxIndex
                //     this.linkInfo.showMode = 'move'
                //     this.father.fastDrawEnd()
                //     this.father.onPaint()
                // }
            })
    }
    /**
     * create button
     * @param {String} name button name
     * @return {Object} button instacne
     * @memberof ClChartLine
     */
    setButton(chart, config, rect) {
        switch (config.clickName) {
            case 'zoomin':
                chart.init({
                        rectMain: rect,
                        info: config,
                    },
                    ( /* result */ ) => {
                        this.changeZoomInfo(-1)
                    })
                break;
            case 'zoomout':
                chart.init({
                        rectMain: rect,
                        info: config,
                    },
                    ( /* result */ ) => {
                        this.changeZoomInfo(1)
                    })
                break;
            case 'locked':
                if (this.linkInfo.showMode === 'locked') {
                    config.curValue = 'opened'
                }
                // console.log(config);
                chart.init({
                    rectMain: rect,
                    info: config,
                },
                ( /* result */ ) => {
                    this.changeLocked()
                })
                break;
            default:
                chart.init({
                        rectMain: rect,
                        info: config,
                    },
                    result => {
                        this.callback({
                            event: 'btndown',
                            name: config.clickName,
                            self : result.self,
                            info: result.info,
                        })
                    })
                break;
        }
    }
    changeLocked() {
        if (this.linkInfo.showMode === 'locked') {
            this.linkInfo.showMode = 'init'
        }
        else {
            this.linkInfo.showMode = 'locked'
            const axisXinfo = this.father.dataLayer.axisXinfo.dataTxt
            this.linkInfo.locked.minXinfo = axisXinfo[this.linkInfo.minIndex]
            this.linkInfo.locked.maxXinfo = axisXinfo[this.linkInfo.maxIndex]
        }
    }
    /**
     * set buttons
     * @memberof ClChartLine
     */
    createButtons() {
        if (this.buttons.length < 1) {
            return
        }
        let chart
        let yy = this.rectButton.top
        let ww = this.rectButton.width / this.buttons.length
        let xx = this.rectButton.left
        for (let index = 0; index < this.buttons.length; index++) {

            const bname = this.buttons[index].clickName
            // console.log(this.childCharts[bname]);
            if (this.childCharts[bname] !== undefined) {
                continue
            }
            chart = new ClChartButton(this)
            chart.name = bname
            this.childCharts[bname] = chart

            this.setButton(chart, this.buttons[index], {
                left: xx,
                top: yy,
                width: ww,
                height: this.rectButton.height
            })
            xx += ww
        }
        // console.log(this.buttons.length, this.childCharts);
    }
    /**
     * set zoom info
     * @memberof ClChartLine
     */
    setZoomInfo() {
        if (this.config.zoomInfo === undefined)  return
        const value = this.config.zoomInfo.list[this.linkInfo.zoomIndex]
        this.linkInfo.unitX = value * this.scale
    }
    initZoomInfo() {
        if (this.config.zoomInfo === undefined)  return
        if (this.linkInfo.zoomIndex === -1) {
            this.linkInfo.zoomIndex = this.config.zoomInfo.index
        }
        this.linkInfo.zoomIndex = this.linkInfo.zoomIndex > this.config.zoomInfo.list.length - 1 ? this.config.zoomInfo.list.length - 1 : this.linkInfo.zoomIndex
        this.linkInfo.zoomIndex = this.linkInfo.zoomIndex < 0 ? 0 : this.linkInfo.zoomIndex
        this.setZoomInfo()
    }
    changeZoomInfo(offset) {
        if (this.config.zoomInfo === undefined)  return
        if (this.linkInfo.showMode === 'locked') return
        
        let changed = false
        if (offset === 1) {
            if (this.linkInfo.zoomIndex < this.config.zoomInfo.list.length - 1) {
                this.linkInfo.zoomIndex++
                changed = true
            }
        }
        else {
            if (this.linkInfo.zoomIndex > 0) {
                this.linkInfo.zoomIndex--
                changed = true
            }
        }
        if (changed) {
            this.setZoomInfo()
            this.father.fastDrawEnd()
            this.father.onPaint()
        }
    }
    /**
     * set hot button
     * @param {Object} chart chart instance
     * @memberof ClChartLine
     */
    // setHotButton(chart) {
    //     for (const name in this.childCharts) {
    //         if (this.childCharts[name] === chart) {
    //             this.childCharts[name].focused = true
    //         } else {
    //             this.childCharts[name].focused = false
    //         }
    //     }
    // }
    /**
     * clear chart
     * @memberof ClChartLine
     */
    drawClear() {
        _fillRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height, this.color.back)
        _drawBegin(this.context, this.color.grid)
        _drawRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height)
        if (this.config.title.display !== 'none') {
            _drawHline(this.context, this.rectMain.left, this.rectMain.left + this.rectMain.width, this.rectTitle.top + this.rectTitle.height)
        }
        if (this.config.axisX.display !== 'none') {
            _drawHline(this.context, this.rectMain.left, this.rectMain.left + this.rectMain.width, this.rectAxisX.top - this.scale)
        }
        _drawEnd(this.context)
    }
    drawWindow() {
        if (this.windowMark) {
            const axisXinfo = this.father.dataLayer.axisXinfo.dataTxt
            const xIndex = this.getIndex(axisXinfo, {
                minXinfo : this.windowMark.min,
                maxXinfo : this.windowMark.max,
                curXinfo : this.windowMark.cur,
            })
            // console.log(this.windowMark, xIndex);
            
            _drawBegin(this.context, this.color.txt)
            // if (xIndex.minIndex >= this.linkInfo.minIndex && 
            //     xIndex.minIndex <= this.linkInfo.maxIndex) {
            //     const xx = this.rectChart.left + (xIndex.minIndex - this.linkInfo.minIndex + 0.5) * (this.linkInfo.unitX + this.linkInfo.spaceX)
            //     _drawVline(this.context, xx, this.rectChart.top, this.rectChart.top + this.rectChart.height)    
                
            //     // const uW = this.linkInfo.unitX + this.linkInfo.spaceX
            //     const uW = this.layout.symbol.pixel
            //     // _drawline(this.context, xx, this.rectChart.top, xx + uW, this.rectChart.top)   
            //     // _drawline(this.context, xx, this.rectChart.top + uW, xx + uW, this.rectChart.top)   
            //     // _drawline(this.context, xx, this.rectChart.top + this.rectChart.height, xx + uW, this.rectChart.top + this.rectChart.height)   
            //     // _drawline(this.context, xx, this.rectChart.top + this.rectChart.height - uW, xx + uW, this.rectChart.top + this.rectChart.height)   
            // }
            // if (xIndex.maxIndex >= this.linkInfo.minIndex && 
            //     xIndex.maxIndex <= this.linkInfo.maxIndex) {
            //     const xx = this.rectChart.left + (xIndex.maxIndex - this.linkInfo.minIndex + 0.5) * (this.linkInfo.unitX + this.linkInfo.spaceX)
            //     _drawVline(this.context, xx, this.rectChart.top, this.rectChart.top + this.rectChart.height)
                
            //     // const uW = this.linkInfo.unitX + this.linkInfo.spaceX
            //     const uW = this.layout.symbol.pixel
            //     // _drawline(this.context, xx, this.rectChart.top, xx - uW, this.rectChart.top)   
            //     // _drawline(this.context, xx, this.rectChart.top + uW, xx - uW, this.rectChart.top)   
            //     // _drawline(this.context, xx, this.rectChart.top + this.rectChart.height, xx - uW, this.rectChart.top + this.rectChart.height)   
            //     // _drawline(this.context, xx, this.rectChart.top + this.rectChart.height - uW, xx - uW, this.rectChart.top + this.rectChart.height)   
            // }
            // if (xIndex.curIndex !== undefined && xIndex.curIndex >= this.linkInfo.minIndex && 
            //     xIndex.curIndex <= this.linkInfo.maxIndex) {
            //     const xx = this.rectChart.left + (xIndex.curIndex - this.linkInfo.minIndex + 0.5) * (this.linkInfo.unitX + this.linkInfo.spaceX)
            //     _drawVline(this.context, xx, this.rectChart.top, this.rectChart.top + this.rectChart.height)
            // }
            {
                const xx0 = this.rectChart.left + (xIndex.minIndex - this.linkInfo.minIndex + 0.5) * (this.linkInfo.unitX + this.linkInfo.spaceX)
                const xx1 = this.rectChart.left + (xIndex.maxIndex - this.linkInfo.minIndex + 0.5) * (this.linkInfo.unitX + this.linkInfo.spaceX)
                const yy0 = this.rectChart.top
                const yy1 = this.rectChart.top + this.rectChart.height
                // const uW = this.linkInfo.unitX + this.linkInfo.spaceX
                const uW = this.layout.symbol.pixel / 2
                _drawDashLine(this.context, xx0, yy0, xx1, yy0, uW)
                _drawDashLine(this.context, xx0, yy1, xx1, yy1, uW)
                _drawDashLine(this.context, xx0, yy0, xx0, yy1, uW)
                _drawDashLine(this.context, xx1, yy0, xx1, yy1, uW)

                const xx = this.rectChart.left + (xIndex.curIndex - this.linkInfo.minIndex + 0.5) * (this.linkInfo.unitX + this.linkInfo.spaceX)
                _drawDashLine(this.context, xx, yy0, xx, yy1)

            }
            _drawEnd(this.context)
        }
    }
    /**
     * draw child charts
     * @memberof ClChartLine
     */
    drawChildCharts() {
        let hotchart
        for (const name in this.childCharts) {
            if (!this.childCharts[name].focused) {
                this.childCharts[name].onPaint()
            } else {
                hotchart = this.childCharts[name]
            }
        }
        if (hotchart) hotchart.onPaint()
    }
    /**
     * before location
     * @memberof ClChartLine
     */
    beforeLocation() {
        for (const name in this.childLines) {
            if (this.childLines[name].beforeLocation) {
                this.childLines[name].beforeLocation()
            }
        }
    }
    /**
     * draw child lines
     * @memberof ClChartLine
     */
    drawChildLines() {
        for (let i = 0; i < this.config.lines.length; i++) {
            const line = this.childLines['NAME' + i]
            const hotKey = this.getLineDataKey(this.config.lines[i])
            line.onPaint(hotKey)
        }
        // for (const name in this.childLines) {
        //     if (this.childLines[name].hotKey !== undefined) {
        //         this.childLines[name].onPaint(this.childLines[name].hotKey)
        //     } else {
        //         this.childLines[name].onPaint(this.hotKey)
        //     }
        // }
    }
    /**
     * According to the record index to obtain a set of data according to the keys, the data is {MA:[]...} is mainly provided for mouse movement
     * @param {Number} index
     * @return {Array}
     * @memberof ClChartLine
     */
    getInfoWidth(info) {
        const title = this.config.title
        let ww = 0
        if (info.label !== undefined) {
            ww += _getTxtWidth(this.context, info.label, title.font, title.pixel) + title.spaceX + this.scale
        }
        if (info.value !== undefined) {
            ww += _getTxtWidth(this.context, ' ' + info.value, title.font, title.pixel) + title.spaceX + this.scale
        }
        if (info.other !== undefined) {
            ww += _getTxtWidth(this.context, ' ' + info.other, title.font, title.pixel) + title.spaceX + this.scale
        }
        return ww
    }
    getMoveData(index) {
        let lines = this.config.lines
        const name = []
        const vals = []
        if (!Array.isArray(lines)) return out
        
        // console.log(this.config.title, this.rectMess);
        // showinfo : 'sorted',
        let value, info, clr
        for (let k = 0; k < lines.length; k++) {
            // console.log(lines[k].info);
            if (lines[k].info === undefined) continue
            if (lines[k].info.drawInfo === 'none') continue
            if (lines[k].info.fieldY !== undefined) {
                if (lines[k].formula === undefined) {
                    value = getValue(this.data, lines[k].info.fieldY, index)
                } else {
                    // console.log(lines[k].info);
                    
                    value = getValue(this.father.getData(lines[k].formula.key), lines[k].info.fieldY,
                        index - this.linkInfo.minIndex)
                }
                info = formatInfo(value, lines[k].info.format, this.static)
                if (lines[k].info.color === undefined) {
                    clr = getLineColor(lines[k].info.colorIndex)
                } else {
                    clr = this.color[lines[k].info.color]
                }
                vals.push({
                    index: k,
                    color: clr,
                    label: lines[k].info.label,
                    value: info
                })
            } else {
                name.push({
                    index: k,
                    color: clr,
                    label: lines[k].info.label
                })
            }
        }
        let nowWidth = 0
        for (let index = 0; index < name.length; index++) {
            nowWidth += this.getInfoWidth(name[index])
        }
        if (this.config.title.showinfo === 'sorted') {
            // 按 value 升序排序
            // const upvals = vals.sort((a, b) => a.value - b.value);
            // 按 value 降序排序
            const upvals = vals.sort((a, b) => parseFloat(b.value) - parseFloat(a.value));
            // console.log(upvals); // 从头尾分别取数据
            let maxnums = upvals.length
            name.push({ color: this.color.red, label : ASCIIMAPS.fcir})
            let maxindex = name.length 
            name.push({ color: this.color.green, label : ASCIIMAPS.fcir})
            nowWidth += 2 * this.getInfoWidth({ color: this.color.red, label : ASCIIMAPS.fcir})
            for (let index = 0; index < maxnums; index++) {
                nowWidth += this.getInfoWidth(upvals[index])
                // console.log(this.rectButton, this.rectMess, index, nowWidth, this.rectMess.width);
                if (nowWidth < this.rectMess.width) {
                    name.splice(maxindex, 0, upvals[index])
                    maxindex++ 
                }
                else {
                    break;
                }
                nowWidth += this.getInfoWidth(upvals[upvals.length - index - 1])
                // console.log(index, nowWidth, this.rectMess.width, upvals[upvals.length - index - 1]);
                if (nowWidth < this.rectMess.width) {
                    name.push(upvals[upvals.length - index - 1])  
                    maxnums --;
                }
                else {
                    break;
                }
            }
        }
        else {
            for (let index = 0; index < vals.length; index++) {
                nowWidth += this.getInfoWidth(vals[index])
                if (nowWidth < this.rectMess.width) {
                    name.push(vals[index])  
                }
                else {
                    break;
                }
            }
        }
        // console.log(name);
        return name
    }
    /**
     * draw title info
     * @param {Number} index title index
     * @memberof ClChartLine
     */
    drawTitleInfo(index) {
        if (this.config.title.display === 'none') return
        if (index === undefined || index < 0 || index > this.linkInfo.maxIndex) index = this.linkInfo.maxIndex
        this.childDraws['TITLE'].onPaint(this.getMoveData(index))
    }
    /**
     * draw child
     * @param {String} name child draw's name
     * @memberof ClChartLine
     */
    drawChildDraw(name) {
        if (this.childDraws[name] !== undefined) {
            if (name === 'TITLE') {
                this.drawTitleInfo(this.linkInfo.cursor.moveIndex)
            } else {
                this.childDraws[name].onPaint()
            }
        }
    }
    /**
     * draw all the layers contained in this area
     * @memberof ClChartLine
     */
    onPaint() {
        // console.log('--2--', this.context, this.data);
        
        this.beforeLocation() // 数据定位前需要做的事情
        // console.log(this.hotKey);
        this.data = this.father.getData(this.hotKey)
        this.locationData()
        // console.log('onPaint', JSON.stringify(this.dataLayer.linkInfo));

        this.father.readyData(this.data, this.config.lines)
        
        _setLineWidth(this.context, this.scale)
        this.drawClear() // 清理画图区
        
        this.drawChildDraw('GRID') // 先画线格
        
        // 为画图做准备工作
        // 画滚动块
        this.readyScroll()
        this.readyDraw()

        this.drawWindow()
        
        this.drawChildDraw('AXISX')
        this.drawChildDraw('AXISY_LEFT')
        this.drawChildDraw('AXISY_RIGHT')

        this.drawChildDraw('TITLE')
        this.drawChildLines() // 画出所有的线

        this.drawChildCharts()

        this.drawCursor()
        // console.log('==1==', this.focused);
        if (this.focused !== undefined) {
            setFocused(this.focused)
        }
        // this.img = _getImageData(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height)
    }
    setFocused(focused) {
        this.focused = focused
        // console.log('==2==', this.focused);
        let clr = this.color.grid
        if (this.focused) {
            clr = this.color.btnhot
        }
        _drawBegin(this.context, clr)
        _drawRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height)
        _drawEnd(this.context)
    }
    // 画图前的准备工作

    /**
     * get middle
     * @param {String} method
     * @return {Number}
     * @memberof ClChartLine
     */
    getMiddle(method) {
        let middle = this.config.axisY.left.middle
        if (method === 'fixedRight') middle = this.config.axisY.right.middle
        if (middle === 'before') return this.static.agoprc
        if (middle === 'zero') return 0
        return 0
    }
    /**
     * calc max and min data
     * @param {Array} data
     * @param {Object} extremum
     * @param {Number} start
     * @param {Number} stop
     * @return {Object}
     * @memberof ClChartLine
     */
    calcMaxMin(data, extremum, start, stop) {
        const mm = {
            // max: 0.0,
            // min: 0.0
        }
        if (extremum.method === 'fixedLeft' || extremum.method === 'fixedRight') {
            const middle = this.getMiddle(extremum.method)
            mm.min = middle * (1 - 0.01)
            mm.max = middle * (1 + 0.01)
        }
        if (data === undefined || isEmptyArray(data.value)) return mm

        let value
        if (start === undefined) start = 0
        if (stop === undefined) stop = data.value.length - 1

        for (let k = start; k <= stop; k++) {
            if (!isEmptyArray(extremum.maxvalue)) {
                for (let m = 0; m < extremum.maxvalue.length; m++) {
                    if (typeof (extremum.maxvalue[m]) !== 'string') continue
                    value = getValue(data, extremum.maxvalue[m], k)
                    if (mm.max === undefined || value > mm.max) {
                        mm.max = value
                    }
                }
            }
            if (!isEmptyArray(extremum.minvalue)) {
                for (let m = 0; m < extremum.minvalue.length; m++) {
                    if (typeof (extremum.minvalue[m]) !== 'string') continue
                    value = getValue(data, extremum.minvalue[m], k)
                    if (mm.min === undefined || value < mm.min) {
                        mm.min = value
                    }
                }
            }
        }

        if (!isEmptyArray(extremum.maxvalue)) {
            for (let m = 0; m < extremum.maxvalue.length; m++) {
                if (typeof (extremum.maxvalue[m]) === 'number') {
                    if (mm.max === undefined || extremum.maxvalue[m] > mm.max) {
                        mm.max = extremum.maxvalue[m]
                    }
                    // mm.max = extremum.maxvalue[m]
                    break
                }
            }
        }
        if (!isEmptyArray(extremum.minvalue)) {
            for (let m = 0; m < extremum.minvalue.length; m++) {
                if (typeof (extremum.minvalue[m]) === 'number') {
                    if (mm.min === undefined || extremum.minvalue[m] < mm.min) {
                        mm.min = extremum.minvalue[m]
                    }
                    // mm.min = extremum.minvalue[m]
                    break
                }
            }
        }

        if (extremum.method === 'fixedLeft' || extremum.method === 'fixedRight') {
            const middle = this.getMiddle(extremum.method)
            if (mm.max === mm.min) {
                if (mm.max > middle) mm.min = middle
                if (mm.min < middle) mm.max = middle
            }
            const maxrate = Math.abs(mm.max - middle) / middle
            const minrate = Math.abs(middle - mm.min) / middle
            if (maxrate < 0.01 && minrate < 0.01 &&
                this.static.style !== STOCK_TYPE_IDX) {
                mm.min = middle * (1 - 0.01)
                mm.max = middle * (1 + 0.01)
            } else {
                if (maxrate > minrate) {
                    // mm.min = middle / (1 + maxrate)
                    mm.min = middle * (1 - maxrate)
                } else {
                    mm.max = middle * (1 + minrate)
                }
            }
            if (mm.min < 0) mm.min = 0
        }
        if (mm.min === undefined) mm.min = 0.0
        if (mm.max === undefined) mm.max = 1.0
        return mm
    }
    /**
     * ready for draw scroll
     * @memberof ClChartLine
     */
    readyScroll() {
        if (this.scroll.display === 'none') return
        if (this.childCharts['HSCROLL'] !== undefined) {
            this.childCharts['HSCROLL'].onChange({
                select: {
                    min: this.linkInfo.minIndex,
                    max: this.linkInfo.maxIndex
                },
                range: this.data.value.length
            })
        }
    }
    /**
     * get data range
     * @param {Array} data
     * @return {Object}
     * @memberof ClChartLine
     */
    getDataRange(data) {
        const out = {
            minIndex: -1,
            maxIndex: -1
        }
        if (isEmptyArray(data.value) || isEmptyArray(this.data.value)) return out
        const start = getValueFidx(this.data, 0, this.linkInfo.minIndex)
        const stop = getValueFidx(this.data, 0, this.linkInfo.maxIndex)
        for (let k = 0; k <= data.value.length - 1; k++) {
            const tt = getValueFidx(data, 0, k)
            if (tt >= start) {
                out.minIndex = k
                break
            }
        }
        for (let k = data.value.length - 1; k >= 0; k--) {
            const tt = getValueFidx(data, 0, k)
            if (tt <= stop) {
                out.maxIndex = k
                break
            }
        }
        return out
    }
    /**
     * location data
     * @memberof ClChartLine
    */
    getIndex(axisXinfo, xInfo) {
        let minIndex = 0
        let maxIndex = axisXinfo.length - 1
        for (let index = 0; index < axisXinfo.length; index++) {
            if (axisXinfo[index] >= xInfo.minXinfo) {
                minIndex = index
                break
            }            
        }
        for (let index = axisXinfo.length - 1; index >= 0; index--) {
            if (axisXinfo[index] <= xInfo.maxXinfo) {
                maxIndex = index
                break
            }            
        }
        let curIndex = undefined
        if (xInfo.curXinfo !== undefined) {
            for (let index = 0; index < axisXinfo.length; index++) {
                // console.log(axisXinfo[index], xInfo.curXinfo);
                if (axisXinfo[index] === xInfo.curXinfo) {
                    curIndex = index
                    break
                }            
            }
        }
        // console.log(xInfo, xInfo.curXinfo, curIndex);
        return { minIndex, maxIndex, curIndex}
    }
    locationData() {
        if (this.data === undefined) return
        const dataNums = getSize(this.data)
        // 
        const info = this.linkInfo;

        this.setZoomInfo()
        info.spaceX = Math.max(this.scale, info.unitX / 3)
        // console.log(info.unitX, info.spaceX);
        info.maxCount = Math.floor(this.rectChart.width / (info.unitX + info.spaceX)) // 整个图形区域最大显示记录数
        const offnums = info.maxCount > dataNums ? dataNums : info.maxCount
        // console.log(info, offnums, info.maxCount, config);
        switch (info.showMode) {
            case 'fixed':
                // 要根据fixed的最大最小值，合并数据
                info.maxIndex = dataNums - 1
                info.minIndex = dataNums - offnums
                break
            case 'locked':
                {
                    const axisXinfo = this.father.dataLayer.axisXinfo.dataTxt
                    const xIndex = this.getIndex(axisXinfo, info.locked)
                    info.minIndex = Math.max(0, xIndex.minIndex)
                    info.maxIndex = Math.min(xIndex.maxIndex, dataNums - 1)   
                    const facts = info.maxIndex - info.minIndex + 1
                    if (facts > offnums) {
                        info.unitX    = (this.rectChart.width - facts * info.spaceX) / facts
                        info.spaceX = Math.max(this.scale, info.unitX / 3)
                    }
                    // const du = info.unitX - Math.floor(info.unitX)
                    // const ds = info.spaceX - Math.floor(info.spaceX)
                    // if (du + ds > 1.0) {
                    //     info.unitX = Math.floor(info.unitX) + 1
                    //     info.spaceX = Math.floor(info.spaceX) + du + ds - 1.0
                    // }
                    // else {
                    //     info.unitX = Math.floor(info.unitX)
                    //     info.spaceX += du 
                    // }
                    info.maxCount = Math.floor(this.rectChart.width / (info.unitX + info.spaceX)) 
                    // console.log(info.unitX, info.spaceX);
                    // console.log(info.showMode, info.maxCount, dataNums, info.minIndex, info.maxIndex);
                }
                break
            case 'move':
                // console.log(info.showMode, info.scroll);
                let minIndex = info.minIndex
                let maxIndex = minIndex + offnums
                if (maxIndex > dataNums - 1) {
                    maxIndex = dataNums - 1
                    minIndex = dataNums - offnums
                }
                info.scroll.index = Math.floor((maxIndex - minIndex) * info.scroll.set + minIndex)  
                minIndex = Math.max(info.scroll.index - Math.floor(offnums / 2), 0) 
                maxIndex = Math.min(info.scroll.index + Math.floor(offnums / 2), dataNums - 1)   
                // info.scroll.count = maxIndex - minIndex + 1       
                info.maxIndex = maxIndex
                info.minIndex = minIndex
                break
            case 'scroll':
                if (info.scroll.index === -1) {
                    let minIndex = info.minIndex
                    let maxIndex = minIndex + offnums
                    if (maxIndex > dataNums - 1) {
                        maxIndex = dataNums - 1
                        minIndex = dataNums - offnums
                    }
                    info.scroll.index = Math.floor((maxIndex - minIndex) * info.scroll.set + minIndex)  
                    minIndex = Math.max(info.scroll.index - Math.floor(offnums / 2), 0) 
                    maxIndex = Math.min(info.scroll.index + Math.floor(offnums / 2), dataNums - 1)   
                    // info.scroll.count = maxIndex - minIndex + 1       
                    info.maxIndex = maxIndex
                    info.minIndex = minIndex
                }
                else {
                    let half = Math.floor(offnums / 2)
                    let left = info.scroll.index - info.minIndex
                    // console.log(info.showMode, info.scroll.index, offnums, half, left);
                    if (half > left) {
                        if (info.minIndex > 0) {
                            if (info.minIndex > half - left) {
                                info.minIndex -= half - left
                            } 
                            else {
                                info.minIndex = 0 
                            }
                        }
                        info.maxIndex = Math.min(info.minIndex + offnums, dataNums - 1)  
                    }
                    else {
                        info.minIndex = Math.max(info.scroll.index - half, 0) 
                        info.maxIndex = Math.min(info.scroll.index + half, dataNums - 1)   
                    }
                    if (info.maxIndex == dataNums - 1 && info.minIndex > 0) {
                        info.minIndex = info.maxIndex - offnums + 1
                    }
                }
                // console.log(info.showMode, info.scroll, dataNums, info.minIndex, info.maxIndex);
                break
            default: // case 'init':
                info.maxIndex = dataNums - 1
                info.minIndex = Math.max(dataNums - offnums, 0)
                break
        }
    }
    /**
     * set ready for draw
     * @memberof ClChartLine
     */
    readyDraw() { // 计算最大最小值等
        
        // console.log(this.linkInfo.minIndex);
        // 求最大最小值
        let mm, maxmin
        // const force = true;   // 由于定义了没有在后面使用，因此注释掉
        for (let i = 0; i < this.config.lines.length; i++) {
            if (this.config.lines[i].extremum === undefined) continue
            if (isEmptyArray(this.config.lines[i].extremum.maxvalue) &&
                isEmptyArray(this.config.lines[i].extremum.minvalue)) continue
            // 只对第一个线和有需要的线计算最大最小值
            // const ds = this.getLineDS(this.config.lines[i]);
            const formula = this.config.lines[i].formula
            if (formula !== undefined) {
                const newdata = this.father.getData(formula.key)
                const range = this.getDataRange(newdata)
                mm = this.calcMaxMin(newdata, this.config.lines[i].extremum,
                    range.minIndex, range.maxIndex)
            } else {
                mm = this.calcMaxMin(this.data, this.config.lines[i].extremum,
                    this.linkInfo.minIndex, this.linkInfo.maxIndex)
            }
            if (maxmin === undefined) maxmin = mm
            else {
                maxmin.max = maxmin.max > mm.max ? maxmin.max : mm.max
                maxmin.min = maxmin.min < mm.min ? maxmin.min : mm.min
            }
        } // for
        // console.log(this.static, maxmin, this.axisYdata, this.config.lines);
        if (maxmin.max !== this.axisYdata.max || maxmin.min != this.axisYdata.min) {
            this.axisYdata.max = maxmin.max
            this.axisYdata.min = maxmin.min
            this.axisYdata.unitY = (this.rectChart.height) / (this.axisYdata.max - this.axisYdata.min) // 一个单位价位多少像素
            // 如果最大最小值变化了需要传递出去
            this.axisYdata.Yhead = this.rectChart.top
            this.axisYdata.Yfoot = this.rectChart.top + this.rectChart.height
            // console.log(this.axisYdata);
            this.callback({
                event: 'changeAxisY',
                axisYdata: this.axisYdata
            })
        }
    }
    /**
     * handle click event
     * @param {Object} event
     * @memberof ClChartLine
     */
    onClick(event) {
        if (this.axisPlatform !== 'phone') {
            this.linkInfo.showCursorLine = !this.linkInfo.showCursorLine
            if (this.linkInfo.showCursorLine) {
                this.father.eventLayer.boardEvent(this.father, 'onMouseMove', event)
            } else {
                event.reDraw = true // 需要重画
                this.father.eventLayer.boardEvent(this.father, 'onMouseOut', event)
            }
        }
    }
    /**
     * handle long press
     * @param {Object} event
     * @memberof ClChartLine
     */
    onLongPress(event) {
        this.linkInfo.showCursorLine = true
        this.father.eventLayer.boardEvent(this.father, 'onMouseMove', event)
    }
    /**
     * handle pinch
     * @param {Object} event
     * @memberof ClChartLine
     */
    // onPinch(event) {
    //     if (!this.config.zoomInfo) {
    //         return
    //     }
    //     if (event.scale > 0) {
    //         this.linkInfo.zoomIndex++
    //     } else {
    //         this.linkInfo.zoomIndex--
    //     }
    //     if (this.linkInfo.zoomIndex < 0) {
    //         this.linkInfo.zoomIndex = 0
    //         return
    //     }
    //     this.changeZoomInfo(this.linkInfo.zoomIndex * 2 + 1)
    //     this.father.onPaint()
    // }
    /**
     * handle mouse out
     * @param {Object} event
     * @memberof ClChartLine
     */
    onMouseOut(event) {
        if (this.linkInfo.showCursorLine || event.reDraw) {
            this.linkInfo.cursor.moveIndex = this.linkInfo.maxIndex
            this.drawTitleInfo(this.linkInfo.cursor.moveIndex)
            // this.father.onPaint(this)
        }
        // console.log(event);
        this.childDraws['CURSOR'].onClear()
        if (event.board === undefined || event.board === 0) {
            this.father.eventLayer.boardEvent(this.father, 'onMouseOut', event, this)
        }
        this.callback({
            event: 'mouseout',
        })
    }
    /**
     * handle mouse wheel
     * @param {Object} event
     * @memberof ClChartLine
     */
    onMouseWheel(event) {
        if (this.config.zoomInfo === undefined) return

        // let step = Math.floor(event.deltaY / 10)
        // if (step === 0) step = event.deltaY > 0 ? 1 : -1
        const step = event.deltaY > 0 ? 1 : -1
        this.changeZoomInfo(step)
    }
    /**
     * handle key down
     * @param {Object} event
     * @memberof ClChartLine
     */
    moveCursor(movestep) {
        let newIndex = this.linkInfo.cursor.moveIndex + movestep
        newIndex = Math.max(this.linkInfo.minIndex, newIndex)
        newIndex = Math.min(this.linkInfo.maxIndex, newIndex)
        if (newIndex !== this.linkInfo.cursor.moveIndex) {
            this.linkInfo.cursor.moveIndex = newIndex
            this.linkInfo.cursor.mousePos.x += movestep * (this.linkInfo.unitX + this.linkInfo.spaceX)
            this.drawCursor(newIndex);
        }
    }
    onKeyDown(event) {
        // if (event.board === undefined || event.board === 0) {
        //     this.father.eventLayer.boardEvent(this.father, 'onKeyDown', event, this)
        // }
        // console.log(this.name, event);
        switch (event.keyCode) {
            case 38: // up
                    this.changeZoomInfo(1)
                    event.break = true;
                break
            case 40: // down
                // console.log(this.config.zoomInfo, this.linkInfo.zoomIndex > 0);
                    this.changeZoomInfo(-1)
                    event.break = true;
                break
            case 37: // left
                this.moveCursor(- 1)
                this.callback({
                    event: 'keydown',
                    key: ' ',
                    code: 'left',
                    keyCode: 32,
                    rect : this.rectChart,
                    mousePos: this.linkInfo.cursor.mousePos,
                    data: this.data.value[this.linkInfo.cursor.moveIndex],
                    // axisXinfo: this.father.dataLayer.axisXinfo.dataTxt[this.linkInfo.cursor.moveIndex]
                })
                event.break = true;
                break
            case 39: // right
                this.moveCursor(1)
                this.callback({
                    event: 'keydown',
                    key: ' ',
                    code: 'right',
                    keyCode: 32,
                    rect : this.rectChart,
                    mousePos: this.linkInfo.cursor.mousePos,
                    data: this.data.value[this.linkInfo.cursor.moveIndex],
                    // axisXinfo: this.father.dataLayer.axisXinfo.dataTxt[this.linkInfo.cursor.moveIndex]
                })
                event.break = true;
                break
            case 32: //
                this.callback({
                    event: 'keydown',
                    key: ' ',
                    code: 'space',
                    keyCode: 32,
                    rect : this.rectChart,
                    mousePos: this.linkInfo.cursor.mousePos,
                    data: this.data.value[this.linkInfo.cursor.moveIndex],
                    // axisXinfo: this.father.dataLayer.axisXinfo.dataTxt[this.linkInfo.cursor.moveIndex]
                })
                event.break = true;
                break
        }
    }
    /**
     * handle mouse move
     * @param {Object} event
     * @memberof ClChartLine
     */
    onMouseStop(event) {
        if (!this.linkInfo.showCursorLine) return
        this.callback({
            event: 'mousestop',
            static: this.static,
            data: this.data.value[this.linkInfo.cursor.moveIndex]
        })
    }
    drawCursor(mouseIndex) {
        if (!this.linkInfo.showCursorLine) return
        
        const axisXinfo = this.father.dataLayer.axisXinfo.dataTxt
        if (mouseIndex === undefined) {
            mouseIndex = -1
            if (this.linkInfo.cursor.axisXvar !== undefined && this.linkInfo.cursor.axisXvar !== axisXinfo[mouseIndex]) {
                for (let index = 0; index < axisXinfo.length; index++) {
                    if (axisXinfo[index] === this.linkInfo.cursor.axisXvar) {
                        mouseIndex = index
                    }   
                } 
            }
            if (mouseIndex === - 1) {
                mouseIndex = axisXinfo.length - 1
            }
        }

        let valueX
        if (mouseIndex >= 0) {
            this.linkInfo.cursor.moveIndex = mouseIndex
            valueX = axisXinfo[mouseIndex]
            this.linkInfo.cursor.axisXvar = valueX
            // console.log(mouseIndex, valueX, this.linkInfo.maxIndex, this.data.value.length, axisXinfo.length);
            this.drawTitleInfo(mouseIndex)
            this.childDraws['CURSOR'].onPaint(this.linkInfo.cursor.mousePos, valueX)
        }
    }
    onMouseMove(event) {
        if (!this.linkInfo.showCursorLine) return
        // console.log(this.name, JSON.stringify(this.linkInfo));

        if (event.board === undefined || event.board === 0) {
            this.father.eventLayer.boardEvent(this.father, 'onMouseMove', event, this)
        }
        // this.draw_clear();
        // 找到X坐标对应的数据索引
        const mousePos = event.mousePos
        // if (this.img !== undefined) {
        //   _putImageData(this.context, this.img, this.rectMain.left, this.rectMain.top)
        // }
        const mouseIndex = this.getMouseMoveData(mousePos.x)
        this.linkInfo.cursor.moveIndex = mouseIndex
        // console.log(this.linkInfo.minIndex, mouseIndex, this.rectChart, inRangeX(this.rectChart, mousePos.x))
        if (inRangeX(this.rectChart, mousePos.x)) {
            this.linkInfo.cursor.mousePos.x = mousePos.x
            this.linkInfo.cursor.mousePos.y = mousePos.y
            this.drawCursor(mouseIndex);
            if (this.linkInfo.showCursorInfo) {
                this.callback({
                    event: 'mousemove',
                    static: this.static,
                    rect : this.rectChart,
                    mousePos : mousePos,
                    data: this.data.value[mouseIndex]
                })
            }
        }
    }
    /**
     * get mouse move data
     * @param {Number} xpos
     * @return {Number}
     * @memberof ClChartLine
     */
    getMouseMoveData(xpos) {
        let index = Math.floor((xpos - this.rectChart.left) / (this.linkInfo.unitX + this.linkInfo.spaceX))
        // const xx = this.rectChart.left + index * (this.linkInfo.unitX + this.linkInfo.spaceX)
        // console.log(xx, index, xpos, this.linkInfo.minIndex);
        // if (xpos < xx) {
        //     index --
        // }
        // if (xpos > xx + this.linkInfo.unitX) {
        //     index ++
        // }
        index = Math.max(0, index)
        return Math.min(this.linkInfo.maxIndex, this.linkInfo.minIndex + index)
    }

    // /// ClChart end.
}